export default __webpack_public_path__ + "static/media/C_Carpet.a40a2f44.jpg";